import { IFormTypes } from './model';

export const formTypes: IFormTypes = {
    document: 'Document',
    pagedForm: 'Paged Form',
};
